import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getStarRatingFilterVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {searchParamToFacet} from 'modules/search/constants'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {StarRatingBottomSheetContentLoadable} from './Loadable'

const filterKeys = [searchParamToFacet.starRatings.param]

export const StarRatingBottomSheet = () => {
  const dispatch = useDispatch()
  const {formatMessage} = useIntl()
  const {
    toggleMultiFilter,
    getFilters,
    submitFilters,
    resetFilters,
    clearFilters
  } = useFiltersForm(filterKeys)

  const {starRatings} = getFilters()

  const isOpen = useSelector(getStarRatingFilterVisibility)

  const handleApply = useCallback(() => {
    submitFilters()
  }, [submitFilters])

  const handleClear = () => {
    if (starRatings) {
      clearFilters()
    } else {
      dispatch(hideOverlay())
    }
  }

  const handleClose = () => {
    dispatch(hideOverlay())
    resetFilters()
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      navBarProps={{
        centerContent: formatMessage(filterMessages.hotelStarClass)
      }}
      bottomBarContent={
        <Box
          display="flex"
          justifyContent="space-between"
          data-id="starRatingsBottomSheetButtons"
        >
          <Button
            dataId="clearFiltersButton"
            onClick={handleClear}
            variant="tertiary"
          >
            <FormattedMessageWrapper id="clear" defaultMessage="Clear" />
          </Button>
          <Button dataId="applyFiltersButton" onClick={handleApply}>
            <FormattedMessageWrapper id="apply" defaultMessage="Apply" />
          </Button>
        </Box>
      }
    >
      {isOpen && (
        <StarRatingBottomSheetContentLoadable
          starRatingFilter={starRatings}
          toggleFilters={toggleMultiFilter}
        />
      )}
    </BottomSheet>
  )
}
